import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export interface CreateQuoteRequestMessage {
    offerId: string;
    supplierId: string;
    customerId: string;
    vesselId: string;
}

export interface CreateOrderRequestMessage {
    offerId: string;
    supplierId: string;
    customerId: string;
    vesselId: string;
}

export const createQuote = async (requestBody: CreateQuoteRequestMessage): Promise<void> => {
    return await authorizedAxiosInstance.post(`/one-port/triggers/create-quote`, requestBody);
};

export const createOrder = async (requestBody: CreateOrderRequestMessage): Promise<void> => {
    return await authorizedAxiosInstance.post(`/one-port/triggers/create-order`, requestBody);
};

export const rebuildMapping = async (offerId: string, confirmedOrderNumber: string): Promise<void> => {
    return await authorizedAxiosInstance.post(`/one-port/triggers/rebuild-transaction`, null, {
        params: {
            offerId,
            confirmedOrderNumber,
        },
    });
};

export interface OnePortProductCatalogueProductMessage {
    productId: string;
    productName: string;
    mpId: string;
    mpName: string;
}

interface OnePortProductCatalogueSnapshotMessage {
    snapshotDate: string;
    fetchedAt: string;
    productCount: number;
    products: OnePortProductCatalogueProductMessage[];
}

export const getLatestProductCatalogueSnapshot = async (): Promise<OnePortProductCatalogueSnapshotMessage> => {
    const response = await authorizedAxiosInstance.get<OnePortProductCatalogueSnapshotMessage>(
        '/one-port/product-catalogue/snapshots/latest'
    );
    return response.data;
};
